import React from "react";

export function FaSkeletonKpis({ count = 5 }) {
  return (
    <div className="fa-kpi-grid">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="fa-kpi">
          <div className="fa-skeleton mb-2" style={{ width: "60%", height: 12 }} />
          <div className="fa-skeleton" style={{ width: "40%", height: 24 }} />
        </div>
      ))}
    </div>
  );
}

export function FaSkeletonTable({ rows = 8 }) {
  return (
    <div className="fa-card p-4">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="fa-skeleton mb-2" style={{ height: 32 }} />
      ))}
    </div>
  );
}
